import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerAnmeldungErstellenAdmin laden';
export const POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerAnmeldungErstellenAdmin ausführen';
export const POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerAnmeldungErstellenAdmin laden erfolgreich';
export const POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerAnmeldungErstellenAdmin Ladefehler';
export const POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerAnmeldungErstellenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerAnmeldungErstellenAdminAction implements Action {
    readonly type = POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnmeldungErstellenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnmeldungErstellenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnmeldungErstellenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAnmeldungErstellenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_ANMELDUNG_ERSTELLEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerAnmeldungErstellenAdminActions =
    PostBenutzerAnmeldungErstellenAdminAction
    | PostBenutzerAnmeldungErstellenAdminAusfuehrenAction
    | PostBenutzerAnmeldungErstellenAdminErfolgreichAction
    | PostBenutzerAnmeldungErstellenAdminFehlerAction
    | PostBenutzerAnmeldungErstellenAdminNichtAusgefuehrtAction
    ;
